module.exports = __webpack_public_path__ + "img/login-hermanoscristianos.0328aff4.svg";